import { OnInit, ViewChild, ElementRef, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { Router } from '@angular/router';

@Component({
    selector: 'equipt-convert',
    templateUrl: './equipt-convert.component.html'
})
export class EquiptConvert implements OnInit {
   message: string;
   targetUrl: string;
   isAdaptive: boolean = false;
   themeType: string = '';
   currentUrl: string = '';
   overviewPage: boolean = false;
   isHideEquiptConvert: boolean = false;
   @ViewChild('nxiupgradePost') equiptPostForm: ElementRef;

    constructor(private nxiRestService: NxiRestService,  @Optional() @Inject('AppSettings') appSettings: any, @Optional() private router: Router) {
        if (appSettings.deviceType && appSettings.deviceType !== 'desktop') {
                this.isAdaptive = true;
            }
        if (appSettings.themeType) {
            this.themeType = appSettings.themeType;
        }
        if (appSettings.isAdvisor) {
            this.isHideEquiptConvert = true;
        }
        this.currentUrl = this.router ? this.router.url : '';
        this.overviewPage = this.currentUrl.includes('overview');
      }

    ngOnInit() {
    }

    submitForm() {
        this.getEquiptConvertParams();
    }

    getEquiptConvertParams() {
        this.nxiRestService.getNxiPortfolioRestUrlResponse('externalUpgrade').subscribe(
             resp => {
                    console.log('Retrieved REST equipt Overview widgets param : ', resp);
                    this.message = resp.message;
                    this.targetUrl = resp.targetUrl;
                    console.log('Retrieved REST equipt Overview message : ', this.message);
                    console.log('Retrieved REST equipt Overview targetUrl : ', this.targetUrl);
                    let inputValue =  '<input type="hidden" name="message" value="' + this.message + '"/>' ;
                    this.equiptPostForm.nativeElement.innerHTML = inputValue;
                    this.equiptPostForm.nativeElement.action = this.targetUrl;
                    this.equiptPostForm.nativeElement.submit();
             }
        );
    }
}
